// extracted by mini-css-extract-plugin
export default {"TypeSelector":"selectTypes_TypeSelector__G7ofz","TypeSelectorItem":"selectTypes_TypeSelectorItem__SZ9mG"};